export default __webpack_public_path__ + "static/media/provident-fund-outline-16px.e4477cef.svg";